/**
 * Geld, einmal hin und einmal zurück.
 *
 * Raporto rechnet in ganzen Rappen – überall, auch in der Datenbank. Nur an
 * der Oberfläche werden daraus Franken, und nur an der Oberfläche darf aus
 * einer Eingabe wieder ein Rappenbetrag werden.
 *
 * Diese beiden Funktionen standen bisher in jedem Bildschirm neu, und sie
 * standen nicht gleich: Die eine liess Hochkommas als Tausendertrenner durch,
 * die andere nicht – «1'250.00» wurde dort zu null. Wer Beträge aus einem
 * Kontoauszug kopiert, kopiert genau solche Zeichen mit.
 *
 * Hier stehen sie einmal. Benutzt werden sie von der Zahlungserfassung und
 * von der Sammelerfassung; die übrigen Bildschirme tragen ihre eigene Fassung
 * noch, und das bleibt so, bis jemand sie aus einem anderen Grund anfasst –
 * ein Umbau quer durch zwanzig Dateien gehört nicht in eine Lieferung über
 * Zahlungen.
 */

/** Rappen als Schweizer Frankenbetrag, ohne Währungszeichen: 125000 → «1’250.00». */
export function rappenAlsText(rappen: number): string {
  return (rappen / 100).toLocaleString('de-CH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

/**
 * Eine Eingabe als Rappen lesen.
 *
 * Erlaubt, was Menschen tippen und Kontoauszüge liefern: Komma statt Punkt,
 * Hochkomma oder Leerzeichen als Tausendertrenner. Was keine Zahl ergibt,
 * wird zu null – der Aufrufer entscheidet, was das bedeutet, und niemand
 * bekommt eine halb geratene Zahl.
 */
export function zuRappen(text: string): number {
  const n = Number(
    String(text)
      .replace(/[’'\s ]/g, '')
      .replace(',', '.')
  )
  return Number.isFinite(n) ? Math.round(n * 100) : 0
}
